var React = require('react');

function Cs (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"12","cy":"12","r":"11","fill":"white","key":0}),React.createElement("path",{"d":"M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z","fill":"#F0F0F0","key":1}),React.createElement("path",{"d":"M11.1302 12C11.1302 12 4.93457 19.0725 4.92871 19.0711C6.73832 20.8807 9.23836 22 11.9998 22C17.5226 22 21.9998 17.5228 21.9998 12H11.1302Z","fill":"#D80027","key":2}),React.createElement("path",{"d":"M4.92893 4.92901C1.02369 8.83424 1.02369 15.1659 4.92893 19.0712C6.54271 17.4574 8.09478 15.9053 12 12.0001L4.92893 4.92901Z","fill":"#0052B4","key":3})]);
}

Cs.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Cs;

Cs.default = Cs;
